import { useState } from 'react';
import GuardedDialog from './GuardedDialog';
import PasswordChangeForm from './PasswordChangeForm';

/* W-053 step 3a -- Change password, opened from beside Sign out on every page, for every role (the super admin included).
   The form is the ONE PasswordChangeForm (shared with the forced screen). A typed password keeps the dialog open on an
   outside click / Escape (GuardedDialog). On success the new token + user are already stored; onChanged hands the user to
   the shell, and the dialog says that every other session has been signed out. */
const card = { background: '#fff', borderRadius: 8, padding: 28, width: 420, boxShadow: '0 8px 24px rgba(0,0,0,0.2)', fontFamily: "'DM Sans',-apple-system,sans-serif" };

export default function ChangePasswordDialog({ user, onClose, onChanged }) {
    const [dirty, setDirty] = useState(false);
    const [done, setDone] = useState(false);
    return (
        <GuardedDialog isDirty={dirty && !done} onClose={onClose} cardStyle={card}>
            <h3 style={{ margin: '0 0 6px', fontSize: 18, color: '#1A1C2E' }}>Change password</h3>
            <p style={{ margin: '0 0 14px', fontSize: 13, color: '#666' }}>Signed in as <strong>{user && user.email}</strong></p>
            {done ? (
                <>
                    <div role="status" style={{ background: '#E8F5E9', color: '#1E7B34', padding: '10px 12px', borderRadius: 4, fontSize: 13, marginBottom: 16 }}>
                        Your password has been changed. Any other place you were signed in has been signed out.
                    </div>
                    <div style={{ textAlign: 'right' }}>
                        <button type="button" onClick={onClose}
                            style={{ padding: '10px 20px', background: '#2A6DB0', color: '#fff', border: 'none', borderRadius: 4, fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>Close</button>
                    </div>
                </>
            ) : (
                <PasswordChangeForm onDirtyChange={setDirty} onCancel={onClose}
                    onSuccess={u => { setDone(true); if (onChanged) onChanged(u); }} />
            )}
        </GuardedDialog>
    );
}
